<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble"><div class="pre" id="pre-005"><span epub:type="pagebreak" id="page_VIII" title="VIII"><h1 class="pre_tit" epub:type="title"><span>InterVarsity Press</span></h1><div class="dev"><p class="txt_courant_centre"><i>Publisher</i></p><p class="txt_courant_centre">Jeff Crosby</p><p class="bl"> </p><p class="txt_courant_centre"><i>Associate Publisher, Director of Editorial</i></p><p class="txt_courant_centre">Cindy Bunch</p><p class="bl"> </p><p class="txt_courant_centre"><i>Editorial Director, IVP Academic</i></p><p class="txt_courant_centre">Jon Boyd</p><p class="bl"> </p><p class="txt_courant_centre"><i>Director of Production</i></p><p class="txt_courant_centre">Benjamin M. McCoy<span epub:type="pagebreak" id="page_IX" title="IX"></span></p><span epub:type="pagebreak" id="page_X" title="X"></span></div></span></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre3.vue?5ca1a763